import { css } from '@emotion/react';

var disabledVariant = function disabledVariant(props) {
  return /*#__PURE__*/css("background:", props.theme.colors.disabledBackground, ";color:", props.theme.colors.textDisabled, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:disabledVariant;"));
};

export { disabledVariant };
